import MaterialPaper from "../../../../__snowpack__/pkg/@mui/material/Paper.js";
import styled from "styled-components";
export const MergeSuggestionsListContainer = styled(MaterialPaper).withConfig({
  displayName: "merge-suggestions-liststyles__MergeSuggestionsListContainer",
  componentId: "sc-yb0c8e-0"
})(["max-height:30.3rem;height:30.3rem;overflow-y:auto;", ""], {
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(243, 244, 246, var(--tw-bg-opacity))",
  padding: "0.5rem"
});
export const MergeSuggestionsListTitleContainer = styled.div.withConfig({
  displayName: "merge-suggestions-liststyles__MergeSuggestionsListTitleContainer",
  componentId: "sc-yb0c8e-1"
})(["", ""], {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center"
});
export const MergeUnitEmptyStateContainer = styled.div.withConfig({
  displayName: "merge-suggestions-liststyles__MergeUnitEmptyStateContainer",
  componentId: "sc-yb0c8e-2"
})(["height:29rem;", ""], {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "1.5rem",
  textAlign: "center",
  boxSizing: "border-box"
});
